import getHospitals from '@api/routes/myvca-api/get-hospitals'
import getChallenge from '@api/routes/myvca-api/get-challenge';
import confirmChallenge from '@api/routes/myvca-api/confirm-challenge';

var VCA = VCA || {};

VCA.AccountChangeHospital = (function ($) {

    var ui = {};

    function cacheUI() {
        // controls
        ui.$hospitalSerachBtn = $('[data-control="hospitalSerachBtn"]');
        ui.$selectHospitalBtn = $('[data-control="selectHospitalBtn"]');
        ui.$setHopital = $('[data-control="setHopital"]');
        ui.$submitChallenge = $('[data-control="submitChallenge"]');
        ui.$editHospitalSelection = $('[data-control="editHospitalSelection"]');
        ui.$loader = $('[data-control="loader"]');
        //regions
        ui.$challengeAddress = $('[data-region="challengeAddress"]');
        ui.$challengeAddress = $('[data-region="challengeAddress"]');
        ui.$missingAddressWrapper = $('[ data-region="missingAddressWrapper"]');
        ui.$petSelectorBox = $('[data-region="petSelectorBox"]');
        ui.$hospitalResults = $('[data-region="hospitalResults"]');
        ui.$hospitalName = $('[data-region="hospitalName"]');
        // message areas
        ui.$noTesultsFound = $('[data-message="noTesultsFound"]');
        // inputs
        ui.$missingAddresInput = $('[data-input="missingAddresInput"]');
        ui.$hospitalSearchInput = $('[data-input="hospitalSearchInput"]');
        // sections
        ui.$hopitalSections = $('.myvca-account-box');
        ui.$selectHospitalSec = $('[data-seciton="selectHospital"]');
        ui.$verifyHospitalSec = $('[data-seciton="verifyHospital"]');
        ui.$hospitalSuccessSec = $('[data-seciton="hospitalSuccess"]');
        ui.$changeErrorSec = $('[data-seciton="changeError"]');


        //other
        ui.token = $('input[name="__RequestVerificationToken"]').val();
        ui.$DataSourceId = $('input[name="DatasourceId"]').val();
        ui.isCanada = $('[data-iscanada]').attr('data-iscanada');
        ui.$Step1Radius = accountFAHRadius;
        ui.$Step1Geocoder;
        ui.$Step1CurrentLat;
        ui.$Step1CurrentLng;
        ui.$Step1Bounds;
        ui.$Step1Coordinates = {};
        ui.$Fired = true;
        ui.$SelectedHospitalName;
        ui.SelectedHospitalID;

        //challenge 

        ui.clientId;
        ui.challengeResponseId;
        ui.addressChallengeId;
        ui.addressChallengeAnswer;
        ui.petNameChallengeId;
        ui.petNameChallengeAnswer;

    }

    function init() {
        if ($('.js-myvca-change-hospital').length <= 0) {
            return;
        }
        cacheUI();
        const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
        let statusValue = urlParams.get("status");

        if(window.location.href.match(/\?./) && statusValue == 'success'){
            ui.$hopitalSections.hide();
            ui.$hospitalSuccessSec.show();
             cancelLoader();
        }
        else{
            ui.$hopitalSections.hide();
            ui.$selectHospitalSec.show();
            bindListeners();
            bindHospitalSelect();
            bindPetSelect();
        }
       
    }

    function bindListeners() {
        ui.$hospitalSerachBtn.on('click', () =>  {initZipcode()});
        ui.$hospitalSearchInput.on('keyup', initZipcode);
        ui.$selectHospitalBtn.on('click', () =>  {checkIfUserExisit()});
        ui.$submitChallenge.on('click', () =>  {postChallengeAnswers()});
        ui.$editHospitalSelection.on('click', () =>  {editHospital()});
    }

    function initZipcode() {
        let zipCodeValue = ui.$hospitalSearchInput.val();
        let maxCharacters = 5;
        let canadaZipCodeRegex = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

        ui.$hospitalSearchInput.removeClass('error');
        ui.$hospitalSearchInput.parent().find('.input-error-text').hide();
     //   ui.$Step1AcctFahErrMsg.hide();

        //Need to check if IsCanada = true
        if (isCanada) {
            let isValidCanadaZipCode = canadaZipCodeRegex.test(zipCodeValue);

            if (isValidCanadaZipCode) {
            //    ui.$Fired = false;
            //    ui.$Step1AcctFahList.hide();
            //    ui.$Step1AcctFahList.empty();
                initGeocoder(zipCodeValue);
            } else {
            //    ui.$Step1AcctFahContainer.hide();
            //    ui.$Step1AcctFahErrMsg.hide();
            //    ui.$Step1AcctFahList.empty();
            }

        } else {
            //Need to limit characters to 5
            if (zipCodeValue.length >= maxCharacters) { 
                ui.$hospitalSearchInput.val(zipCodeValue.substr(0, maxCharacters));
            }

            if (zipCodeValue.length < maxCharacters) {
         //       ui.$Step1AcctFahContainer.hide();
          //      ui.$Step1AcctFahErrMsg.hide();
          //      ui.$Step1AcctFahList.empty();
            }

            if (zipCodeValue.length === maxCharacters && ui.$Fired) {
          //      ui.$Fired = false;
           //     ui.$Step1AcctFahList.hide();
         //       ui.$Step1AcctFahList.empty();
                initGeocoder(zipCodeValue);
            }
        }
    }
    function initGeocoder(zipCodeValue) {
        let zipCode = zipCodeValue;

       ui.$noTesultsFound.hide();
       ui.$selectHospitalBtn.addClass('disabled');
     //   ui.$Step1AcctFahContainer.css('border', 'none').show();
     //   ui.$Step1LoaderSpinner.show();

        //****** GEOCODER *******
        ui.$Step1Geocoder = new google.maps.Geocoder();
        ui.$Step1Geocoder.geocode({
            'address': zipCode
        }, function (results, status) {
            if (status == 'OK') {
                ui.$Step1CurrentLat = results[0].geometry.location.lat();
                ui.$Step1CurrentLng = results[0].geometry.location.lng();
                ui.$Step1Coordinates = getSearchBounds();
                getHospitalsList(ui.$Step1Coordinates);
            } else {
                console.log('Geocode was not successful for the following reason: ' + status);
                ui.$hospitalResults.html('').hide();
                ui.$noTesultsFound.show();
              //  ui.$Step1AcctFahInvalidZipCodeErrMsg.show();
                ui.$Fired = true;
            }
        });
    }

    function getSearchBounds() {
        ui.$Step1Bounds = getBounds(ui.$Step1CurrentLat, ui.$Step1CurrentLng, ui.$Step1Radius);
        let coordinatesResult = calcMinMaxLatLng(ui.$Step1Bounds);

        return coordinatesResult;
    }

    function getBounds(lat, lng, radius) {
        let ConvertedRadius = radius * 1609.34;

        // add to canada site
         if(ui.isCanada === 'true'){
             ConvertedRadius = radius * 1000;
         }

        var circleData = {
            center: {
                lat,
                lng
            },
            radius: ConvertedRadius
        };

        if (window['google']) {
            return new window['google'].maps.Circle(circleData).getBounds();
        }
    }

    function calcMinMaxLatLng(bounds) {
        var obj = {
            minLat: bounds.getNorthEast().lat(),
            maxLat: bounds.getSouthWest().lat(),
            minLng: bounds.getNorthEast().lng(),
            maxLng: bounds.getSouthWest().lng()
        }
        return obj;
    }

    async function getHospitalsList(coordinates) {

        searchLoading();

        let payload = {
            minLat: coordinates.minLat,
            maxLat: coordinates.maxLat,
            minLong: coordinates.minLng,
            maxLong: coordinates.maxLng,
        }

        const { success, data, error }  = await getHospitals.query(payload);
        let hosptialList = data
        console.log('Response: ',hosptialList);
        if(!success){
            ui.$hopitalSections.hide();
            cancelLoader();
            ui.$changeErrorSec.show();
            console.log('failed', error);
            return;
        }else if(hosptialList === undefined || hosptialList == null || hosptialList.length <= 0){
            ui.$hospitalResults.html('').hide();
            ui.$noTesultsFound.show();
            cancelLoader()
        }else{
            let hospitalsAry = '';
            $.each(hosptialList, function (i, item) {
                hospitalsAry += `
                    <div class="myvca-change-hospital__hospital-list__item form-check custom-radio">
                        <input data-hospitalid="${item.HospitalId}" data-name="${item.DisplayName}" name="hospital-result" id="${item.HospitalId}" value="${item.DisplayName}" class="form-check-input custom-control-input js-hospital-item" type="radio">
                        <label class="form-check-label" for="${item.HospitalId}">
                        ${item.DisplayName}
                        </label>
                    </div>
                `;
            });
        ui.$hospitalResults.html(hospitalsAry).show();
        cancelLoader()
        }
    }

    async function checkIfUserExisit() {
        startLoader();
        let payload = {
            hospitalId: ui.SelectedHospitalID
        }
        const { success, data, error }  = await getChallenge.query(payload);
        if(!success){
            ui.$hopitalSections.hide();
            cancelLoader();
            ui.$changeErrorSec.show();
            console.log('failed', error);
            return;
        }
        let response = data
        // console.log('challenge' , response);
        if (response.ChallengeResponse != null && response.ChallengeResponse.petNameChallenge != null) {
            if(response.ChallengeResponse.addressChallenge != null){
                ui.addressChallengeId = response.ChallengeResponse.addressChallenge.id;
                let n = response.ChallengeResponse.addressChallenge.gapLength;
                let spaces = new Array(++n).join('*');
                let address = response.ChallengeResponse.addressChallenge.preGap + spaces + response.ChallengeResponse.addressChallenge.postGap;
                ui.$challengeAddress.text(address);
            }else{
                ui.$missingAddresInput.val('null');
                ui.$missingAddressWrapper.hide();
            }
            ui.clientId = response.ClientId;
            ui.challengeResponseId = response.ChallengeResponse.id;
            ui.petNameChallengeId = response.ChallengeResponse.petNameChallenge.id;

            //console.log('pet' , response.petNameChallenge.choices);

            ui.$petSelectorBox.empty();
            let petsChoices = response.ChallengeResponse.petNameChallenge.choices
            let petInputs = '';
            $.each(petsChoices, function (i, name) {
                petInputs  +=  `
                <div class="form-label-group">
                    <div class="form-check custom-radio">
                        <input class="form-check-input custom-control-input" type="radio" name="petName" id="${name}" value="${name}">
                        <label class="form-check-label" for="${name}">
                        ${name}
                        </label>
                    </div>
                </div>
            `;
            });
            ui.$petSelectorBox.html(petInputs);

            ui.$hopitalSections.hide();
            ui.$verifyHospitalSec.show();
            cancelLoader();

        
        }else{
            ui.$hopitalSections.hide();
            cancelLoader();
            ui.$changeErrorSec.show();
            console.log('failed', error);
            return;
        }

    }

    async function postChallengeAnswers() {
        startLoader();

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }

        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');

        let payload = {
            hospitalId: ui.SelectedHospitalID,
            clientId: ui.clientId,
            challengeSetId: ui.challengeResponseId,
            addressChallengeId: ui.addressChallengeId,
            addressChallengeAnswer: ui.addressChallengeAnswer,
            petNameChallengeId: ui.petNameChallengeId,
            petNameChallengeAnswer: ui.petNameChallengeAnswer,
            '__RequestVerificationToken': ui.token
        }
        console.log('payload post',payload);
        const { success, data, error }  = await confirmChallenge.post(searchParams(payload), axiosConfig);
        let response = data;

        if(!success || !response){
            ui.$hopitalSections.hide();
            cancelLoader();
            ui.$changeErrorSec.show();
            console.log('failed', error);
            return;
        }
        else {
            window.location.href = window.location.href + "&status=success";
            // ui.$hopitalSections.hide();
           // ui.$hospitalSuccessSec.show();
           // cancelLoader();
        }
    }

    function editHospital() {
        ui.$hopitalSections.hide();
        ui.$selectHospitalSec.show();
        ui.$submitChallenge.addClass('disabled');
        ui.$missingAddresInput.val('');
    }

    function bindHospitalSelect() {
        ui.$hospitalResults.on('click', 'input', function (e) {
            if ($(e.target).is(':checked')) {
                ui.$hospitalName.text(e.target.value);
                ui.$SelectedHospitalName = e.target.value;
                ui.SelectedHospitalID = e.target.dataset.hospitalid;
                ui.$selectHospitalBtn.removeClass('disabled');
            }else{
                return;
            }
        });
    }

    function bindPetSelect() {
        ui.$verifyHospitalSec.on('change keyup', 'input', function (e) {
            if (ui.$missingAddresInput.val().length == '') {
                ui.$submitChallenge.addClass('disabled');
            }else if(ui.$petSelectorBox.find('input:checked').length <= 0){
                ui.$submitChallenge.addClass('disabled');
            }else{
                ui.$submitChallenge.removeClass('disabled');
                ui.addressChallengeAnswer = ui.$missingAddresInput.val();
                ui.petNameChallengeAnswer = ui.$petSelectorBox.find('input:checked').val();
            }
        });
    }

    function searchLoading() {
        ui.$noTesultsFound.hide();
        ui.$selectHospitalBtn.addClass('disabled');
        ui.$hospitalResults.html('').hide();
        startLoader();
    }

    function startLoader() {
        ui.$loader.show();
        ui.$hopitalSections.addClass('-loading');
    }

    function cancelLoader() {
        ui.$loader.hide();
        ui.$hopitalSections.removeClass('-loading');
    }


    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.AccountChangeHospital.init();
});